document.addEventListener('DOMContentLoaded', () => {

    const mainForm = document.getElementById('product-form-main');
    const mobileForm = document.getElementById('product-form-mobile');
    document.addEventListener('scroll', () => {
        if(aboveViewport(mainForm)){
            mobileForm.style.opacity = '1';
            mobileForm.style.visibility = 'visible';
        }else{
            mobileForm.style.opacity = '0';
            mobileForm.style.visibility = 'hidden';
        }
    });
});

const aboveViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.bottom <= 0
    );
}